<div class="form-group container" id="company-detail-detail-component" *ngIf="company">
    <form #updateCompanyForm="ngForm">
        <div class="row">
            <div>
                <h1 *ngIf="type === 'update'"><i class="fa fa-building-o fa-pre" aria-hidden="true"></i> {{companyName}}
                </h1>
                <h1 *ngIf="type === 'create'"><i class="fa fa-building-o fa-pre" aria-hidden="true"></i>
                    {{'companies.create.header' | translate}}</h1>
                <h2 *ngIf="type === 'createInModal'" style="margin-left: 30px"><i class="fa fa-building-o fa-pre"
                        aria-hidden="true"></i>
                    {{'companies.create.header' | translate}}</h2>
                <div style="margin-top:30px;">
                    <div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <h3 style="margin-left: 30px">Requis</h3>
                        </div>

                        <!-- Groupe -->
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="companyGroup" class="required">Groupe</label>
                                </div>

                                <div class="col-md-8">
                                    <input auto-complete [(ngModel)]="companyGroupName"
                                           [source]="searchCompanyGroups.bind(this)"
                                           value-property-name="id" [list-formatter]="formatCompanyGroups"
                                           [accept-user-input]="false"
                                           [min-chars]="1" [max-num-list]="10" display-property-name="name"
                                           id="companyGroup"
                                           class="form-control" (valueChanged)="changeCompanyGroup($event)"
                                           name="companyGroup"
                                           autocomplete="off" placeholder="Aucun groupe">
                                </div>

                                <div class="col-md-1 input-ok">
                                    <span class="check" *ngIf="isCompanyGroupValid()">
                                        <i class="fa fa-check" aria-hidden="true"></i>
                                    </span>
                                    <span class="times" *ngIf="!isCompanyGroupValid()">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <a (click)="removeFromCompanyGroup()" class="remove-column">
                                    <button [disabled]="!company.companyGroup"
                                        class="btn btn-default fa fa-trash-o"></button>
                                </a>
                            </div>
                        </div>

                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="name" class="required">{{ 'companies.name' | translate}}</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" id="name" required #name="ngModel"
                                        name="name" [(ngModel)]="company.name">
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <h3 style="margin-left: 30px">{{'global.form.optional'| translate}}</h3>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="commercial">{{ 'companies.detail.commercial' | translate}}</label>
                                </div>
                                <div class="col-md-8">
                                    <input id="commercial" class="form-control commercial" auto-complete
                                           #commercial="ngModel" [(ngModel)]="company.companyExtended.commercial"
                                           [list-formatter]="formatCommercials" display-property-name="fullname"
                                           [source]="searchCommercials.bind(this)"
                                           [ngModelOptions]="{standalone: false}"
                                           [accept-user-input]="false" [min-chars]="1" [max-num-list]="7"
                                           name="commercial" autocomplete="off"
                                           placeholder="Pas de commercial associé"/>
                                </div>
                                <div class="col-md-1 input-ok">
                                    <span class="check" *ngIf="isCompanyCommercialValid()">
                                        <i class="fa fa-check" aria-hidden="true"></i>
                                    </span>
                                    <span class="times" *ngIf="!isCompanyCommercialValid()">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <a (click)="removeFromCompanyCommercial()" class="remove-column">
                                    <button [disabled]="!this.companyCommercialName"
                                        class="btn btn-default fa fa-trash-o"></button>
                                </a>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="siret">{{ 'companies.detail.siret' | translate}}</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" id="siret" #name="ngModel" name="siret"
                                        [(ngModel)]="company.siret">
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="address1">{{ 'companies.detail.address1' | translate}}</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" id="address1" #name="ngModel"
                                        name="address1" [(ngModel)]="company.address1">
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">

                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" id="address2" #name="ngModel"
                                        name="address2" [(ngModel)]="company.address2">
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="zipCode">{{ 'companies.zipCode' | translate}}</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" id="zipCode" #name="ngModel" name="zipCode"
                                        [(ngModel)]="company.zipCode">
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="city">{{ 'companies.city' | translate}}</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" id="city" #name="ngModel" name="city"
                                        [(ngModel)]="company.city">
                                </div>
                            </div>
                        </div>

                        <div style="margin:0 30px 15px;">
                            <button style="margin-top: 20px;" class="btn btn-primary" type="submit"
                                [disabled]="!updateCompanyForm.valid" name="submit" (click)="save()">Sauvegarder
                            </button>
                            <button style="margin-top: 20px;" *ngIf="type === 'update'" class="btn btn-default"
                                (click)="removeCompany(company)">Supprimer
                            </button>
                        </div>

                        <div *ngIf="type !== 'create'">
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <h3 style="margin-left: 30px">{{'companies.detail.session.title' | translate}}</h3>
                            </div>

                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="subtitle">
                                    {{'companies.detail.extract.title' | translate}}
                                </div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced extract-container">
                                <span>
                                    {{'companies.detail.extract.minStartDate' | translate}}
                                </span>
                                <input
                                    type="date"
                                    class="form-control"
                                    id="minStartDate"
                                    required #name="ngModel"
                                    name="minStartDate"
                                    [(ngModel)]="evaluationExportRequest.minStartDate"
                                />
                                <span>
                                    {{'companies.detail.extract.maxStartDate' | translate}}
                                </span>
                                <input
                                    type="date"
                                    class="form-control"
                                    id="maxStartDate"
                                    required #name="ngModel"
                                    name="maxStartDate"
                                    [(ngModel)]="evaluationExportRequest.maxStartDate"
                                />
                                <span>
                                    {{'companies.detail.extract.exportFormat' | translate}}
                                </span>
                                <select
                                    class="form-control"
                                    id="exportFormat"
                                    required #name="ngModel"
                                    [(ngModel)]="evaluationExportRequest.exportFormat"
                                    name="exportFormat"
                                >
                                    <option value="CSV">CSV</option>
                                    <option value="PDF">PDF</option>
                                </select>
                                <button
                                    class="btn btn-default"
                                    (click)="extractEvaluations()"
                                >
                                    {{'companies.detail.extract.download' | translate}}
                                </button>
                                <a
                                    *ngIf="evaluationExportRequest.exportFormat === 'CSV'"
                                    class="btn btn-link"
                                    [href]="'companies.detail.extract.excelHelpLink' | translate"
                                    target="_blank">
                                    <span class="fa fa-file-excel-o"></span>
                                    {{'companies.detail.extract.excelHelpLabel' | translate}}
                                </a>
                                <a
                                    *ngIf="evaluationExportRequest.exportFormat === 'CSV'"
                                    class="btn btn-link"
                                    [href]="'companies.detail.extract.gsheetHelpLink' | translate"
                                    target="_blank">
                                    <span class="fa fa-table"></span>
                                    {{'companies.detail.extract.gsheetHelpLabel' | translate}}
                                </a>
                            </div>

                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="subtitle">{{'companies.detail.session.upcoming.title' | translate}}</div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <table class="table table-striped table-hover">
                                    <thead>
                                    <tr>
                                        <th style="width: 25%">{{ 'companies.detail.session.training.title' | translate}}</th>
                                        <th style="width: 25%">{{ 'companies.detail.session.startDate' | translate}}</th>
                                        <th style="width: 25%">{{ 'companies.detail.session.student.name' | translate}}</th>
                                        <th style="width: 25%">{{ 'companies.detail.session.student.evaluation' | translate}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngIf="!companyUpcoming" style="text-align: center;"><td colspan="5">Chargement...</td></tr>
                                    <tr *ngIf="companyUpcoming && companyUpcoming.length === 0" style="text-align: center;"><td colspan="5">Aucune session</td></tr>
                                    <tr *ngFor="let history of companyUpcoming">
                                        <td>
                                            <a uiSref="session-detail" [uiParams]="{ id: history.sessionId }">
                                                {{history.trainingTitle}}
                                            </a>
                                        </td>
                                        <td>
                                            {{history.startDate | date : "dd/MM/y"}}
                                        </td>
                                        <td>
                                            <a *ngFor="let student of history.students">
                                                {{student.firstname}} {{student.lastname}}
                                            </a>
                                        <td>
                                            <a *ngFor="let student of history.students">
                                                {{student.averageEvaluation}}/5
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <div class="subtitle">{{'companies.detail.session.history.title' | translate}}</div>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <table class="table table-striped table-hover">
                                    <thead>
                                    <tr>
                                        <th style="width: 25%">{{ 'companies.detail.session.training.title' | translate}}</th>
                                        <th style="width: 15%">{{ 'companies.detail.session.startDate' | translate}}</th>
                                        <th style="width: 25%">{{ 'companies.detail.session.student.name' | translate}}</th>
                                        <th style="width: 25%"></th>
                                        <th style="width: 10%">{{ 'companies.detail.session.student.evaluation' | translate}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngIf="!companyHistories" style="text-align: center;"><td colspan="5">Chargement...</td></tr>
                                    <tr *ngIf="companyHistories && companyHistories.length === 0" style="text-align: center;"><td colspan="5">Aucune session</td></tr>
                                    <tr *ngFor="let history of companyHistories">
                                        <td>
                                            <a uiSref="session-detail" [uiParams]="{ id: history.sessionId }">
                                                {{history.trainingTitle}}
                                            </a>
                                        </td>
                                        <td>
                                            {{history.startDate | date : "dd/MM/y"}}
                                        </td>
                                        <td>
                                            <a *ngFor="let student of history.students">
                                                {{student.firstname}} {{student.lastname}}
                                            </a>
                                        </td>
                                        <td>
                                            <a *ngFor="let student of history.students">
                                                <span *ngIf="student.employerCompany.id !== company.id">
                                                    {{ 'companies.detail.session.student.employedBy' | translate }}
                                                    {{ student.employerCompany.name }}
                                                </span>
                                                <span *ngIf="student.registeringCompany.id !== company.id">
                                                    {{ 'companies.detail.session.student.registeredBy' | translate }}
                                                    {{ student.registeringCompany.name }}
                                                </span>
                                            </a>
                                        </td>
                                        <td>
                                            <a *ngFor="let student of history.students">
                                                {{student.averageEvaluation?.toFixed(1) || '-'}}/5
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <h3 style="margin-left: 30px">{{'companies.detail.subCompany.title' | translate}}</h3>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th style="width: 50%">{{ 'companies.detail.subCompany.name' | translate}}
                                            </th>
                                            <th style="width: 50%">{{ 'companies.detail.subCompany.siret' | translate}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let subCompany of subCompanies">
                                            <td>
                                                <a uiSref="jhi-companies" [uiParams]="{ id: subCompany.id }">
                                                    {{subCompany.name}}
                                                </a>
                                            </td>
                                            <td>
                                                <a uiSref="jhi-companies" [uiParams]="{ id: subCompany.id }">
                                                    {{subCompany.siret}}
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <h3 style="margin-left: 30px">Contacts</h3>
                            </div>
                            <div class="plt-display-row col-md-12 plt-b-spaced">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th style="width: 10%">{{ 'companies.detail.contact.type' | translate}}</th>
                                            <th style="width: 18%">{{ 'companies.detail.contact.firstName' | translate}}
                                            </th>
                                            <th style="width: 18%">{{ 'companies.detail.contact.lastName' | translate}}
                                            </th>
                                            <th style="width: 30%">{{ 'companies.detail.contact.email' | translate}}
                                            </th>
                                            <th style="width: 12%">{{ 'companies.detail.contact.job' | translate}}</th>
                                            <th style="width: 12%">{{ 'companies.detail.contact.phone' | translate}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let contact of contacts">
                                            <td>
                                                <a uiSref="contacts-detail" [uiParams]="{ id: contact.id }">
                                                    {{contact.type}}
                                                </a>
                                            </td>
                                            <td>
                                                <a uiSref="contacts-detail" [uiParams]="{ id: contact.id }">
                                                    {{contact.firstName}}
                                                </a>
                                            </td>
                                            <td>
                                                <a uiSref="contacts-detail" [uiParams]="{ id: contact.id }">
                                                    {{contact.lastName}}
                                                </a>
                                            </td>
                                            <td>
                                                <a uiSref="contact-detail" [uiParams]="{ id: contact.id }">
                                                    {{contact.email}}
                                                </a>
                                            </td>
                                            <td>
                                                <a uiSref="contacts-detail" [uiParams]="{ id: contact.id }">
                                                    {{contact.job}}
                                                </a>
                                            </td>
                                            <td>
                                                <a uiSref="contact-detail" [uiParams]="{ id: contact.id }">
                                                    {{contact.phone}}
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/company/detail/detail.component.html